import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";
import "../assets/css/style.css";
import AspirantsParDistrictChart from "../components/region/AspirantsParDistrictChart";
import RegionDistrictEgliseAspirants from "../components/region/RegionDistrictEgliseAspirants";

export default function DashboardRegion() {
  const navigate = useNavigate();
  const [aspirants, setAspirants] = useState([]);
  const [memoires, setMemoires] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [eglises, setEglises] = useState([]);
  const [totalAspirants, setTotalAspirants] = useState(0);
  const [totalCG, setTotalCG] = useState(0);
  const [totalSYL, setTotalSYL] = useState(0);
  const [regionName, setRegionName] = useState("");

  useEffect(() => {
    // Récupérer le nom de la région
    api.get("/auth/me")
      .then((res) => {
        const userData = res.data?.user || res.data;
        setRegionName(userData?.region?.name || "");
      })
      .catch((err) => console.error("Erreur chargement région:", err));

    api.get("/region/aspirants")
      .then((res) => setAspirants(res.data))
      .catch((err) => console.error("Erreur chargement aspirants:", err));

    api.get("/region/memoires/en_attente")
      .then((res) => setMemoires(res.data))
      .catch((err) => console.error("Erreur chargement memoires:", err));

    api.get("/districts/by-region")
      .then((res) => setDistricts(res.data))
      .catch((err) => console.error("Erreur chargement districts:", err));

    api.get("/aspirants/region/count")
      .then(res => setTotalAspirants(res.data.total))
      .catch(err => console.error("Erreur total aspirants région :", err));

    api.get("/aspirants/region/count-parcours")
      .then(res => {
        setTotalCG(res.data.total_CG);
        setTotalSYL(res.data.total_SYL);
        console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa",res.data);

      }
    )
      .catch(err => console.error("Erreur CG/SYL région :", err));
  }, []);

  const handleValidation = async (id, status) => {
    try {
      await api.patch(`/region/memoires/${id}/validate`, { is_validated: status });
      setMemoires(memoires.filter((m) => m.id !== id));
    } catch (err) {
      alert("Erreur lors de la mise à jour");
    }
  };

  const handleDistrictClick = async (district) => {
    setSelectedDistrict(district);
    try {
      const res = await api.get(`/locations/eglises/by-district/${district.id}`);
      setEglises(res.data);
    } catch (err) {
      console.error("Erreur chargement églises :", err);
      setEglises([]);
    }
  };

  return (
    <div className="d-flex flex-column flex-grow-1 h-100">
      <div className="flex-grow-1 overflow-auto px-3 py-2">
        <div className="d-flex flex-column h-100" style={{ minHeight: "100vh" }}>
          <header className="d-flex justify-content-between align-items-center mb-4 pb-3 px-3 pt-3">
            <h2 className="text-primary m-0 text-center flex-grow-1">
              Bienvenue sur votre dashboard de Coordinateur de Région <small className="text-red mt-1">{regionName}</small>
            </h2>
          </header>

          <div className="px-4">
          <div className="row g-3">
            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "rgb(199 212 223)" }}>
                <div className="card-body">
                    <h6 className="card-title text-nowrap" style={{ fontSize: "0.85rem" }}>
                      <i className="bi bi-people-fill me-2"></i>Total Elèves
                    </h6>
                    <h3 className="mb-0">{totalAspirants}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#0d6efd" }}>
                <div className="card-body">
                    <h6 className="card-title text-nowrap" style={{ fontSize: "0.85rem" }}>
                      <i className="bi bi-person-check-fill me-2"></i>Elèves Chef Guide
                    </h6>
                    <h3 className="mb-0">{totalCG}</h3>
                </div>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card shadow-sm text-white" style={{ backgroundColor: "#6e0b14" }}>
                <div className="card-body">
                  <h6 className="card-title text-nowrap" style={{ fontSize: "0.85rem" }}>
                    <i className="bi bi-person-check-fill me-2"></i>Elèves SYL
                  </h6>
                  <h3 className="mb-0">{totalSYL}</h3>
                </div>
              </div>
            </div>
          </div>
            <div className="d-none d-md-block">
              <AspirantsParDistrictChart />
            </div>
            <div className="row  mb-4">
              <div className="col-md-12">
                <RegionDistrictEgliseAspirants />
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
